<template>
  <div id="navigation-mobile">
    <ul class="nav_ul">
      <li v-for="(item, index) in Menus" :key="index">
        <!-- click做二件事以逗號分開 -->
        <a
          @click="
            SET_MENUID(item.power_id), $store.commit('SET_SHOWNAV', false)
          "
          >{{ item.power_title }}</a
        >
      </li>
    </ul>
    <!-- <ul>
      <li>關於中心</li>
      <li>團隊介紹</li>
      <li>服務內容</li>
      <li>最新消息</li>
      <li>衛教專區</li>
      <li>資源連結</li>
    </ul> -->
  </div>
</template>

<script>
import api from "../utils/apis/DepApi.js";
import { mapMutations } from "vuex";
export default {
  name: "NavigationMobile",

  data: () => ({
    mobileView: true,
    CloseNav: false,
    Menus: [],
  }),
  mounted() {
    this.getMenuInf();
  },
  methods: {
    ...mapMutations(["SET_MENUDATA", "SET_MENUID"]),

    getMenuInf() {
      //   this.loading = true;
      api
        .CtrMenu()
        .then(
          (response) => (
            (this.Menus = response.data.Data),
            this.SET_MENUDATA(response.data.Data)
          )
        )
        .catch((err) => console.log(err))
        .finally();
    },
  },
};
</script>

<style lang="scss" scoped>
#navigation-mobile {
  // position:relative;
  // top:0;
  // left:0;
  //  height: 100vh;
  background-color: #fff;
  padding: 0;
  ul {
    list-style: none;
    width: 100%;
    padding-top: 80px;
    padding-left: 30px;

    li {
      color: #333;
      font-size: 1.25rem;
      font-weight: bold;
      margin-bottom: 20px;
      cursor: pointer;
      border-bottom: 1px solid #ccc;
      // text-align:center;
    }
    li:hover {
      color: #f39d92;
    }
  }
  //   .close {
  //   transform: translateX(0px);
  // }
}
</style>
